import { Paper, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Button } from "@powerdiary/components-library/lib";
import DocumentIcon from "./DocumentIcon";

interface INoSharedDocumentsProps {
    onUploadClick: () => void;
}

export default function NoSharedDocuments({ onUploadClick }: Readonly<INoSharedDocumentsProps>) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

    return (
        <Paper>
            <Stack
                alignItems="center"
                direction={isMobile ? "column" : "row"}
                p={isMobile ? 2 : 4}
                data-test-id="section_no_shared_documents"
            >
                <DocumentIcon />

                <Stack direction="column" spacing={2} justifyContent="center">
                    <Typography
                        variant="h6"
                        sx={{
                            textAlign: isMobile ? "center" : "left",
                        }}
                    >
                        You don&apos;t have any shared documents yet
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            textAlign: isMobile ? "center" : "left",
                        }}
                    >
                        When your practitioner shares documents with you, they&apos;ll appear here for easy access. Stay
                        organized and keep track of everything in one place.
                    </Typography>
                    <Stack direction="row" justifyContent={isMobile ? "center" : "flex-start"}>
                        <Button
                            variant="outlined"
                            size="extraSmall"
                            type="button"
                            onClick={onUploadClick}
                            data-test-id="button_upload_document"
                        >
                            Upload a Document Instead?
                        </Button>
                    </Stack>
                </Stack>
            </Stack>
        </Paper>
    );
}
